var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: _vm.titulo,
        width: 1000,
        height: 700,
        bodyStyle: { height: "auto", padding: "0" }
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.abaAtiva,
                callback: function($$v) {
                  _vm.abaAtiva = $$v
                },
                expression: "abaAtiva"
              }
            },
            [
              _c("el-tab-pane", { attrs: { name: "cadastro" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label", id: "CADASTRO" }, slot: "label" },
                  [_vm._v("Cadastro  ")]
                ),
                _c(
                  "div",
                  [
                    _c("tabs-visualizar-gleba", {
                      attrs: { idGleba: _vm.idGleba }
                    })
                  ],
                  1
                )
              ]),
              _c("el-tab-pane", { attrs: { name: "processosVinculados" } }, [
                _c(
                  "span",
                  {
                    attrs: { slot: "label", id: "PROCESSOSVINCULADOS" },
                    slot: "label"
                  },
                  [_vm._v("Processos vinculados  ")]
                ),
                _vm.possuiVinculoProcesso
                  ? _c(
                      "div",
                      { staticClass: "exportar" },
                      [
                        _c("el-button", { on: { click: _vm.getCsv } }, [
                          _vm._v("Exportar CSV")
                        ])
                      ],
                      1
                    )
                  : _c("div", { staticClass: "exportar" }, [
                      _c("p", [
                        _vm._v("A gleba não possui processos vinculados.")
                      ])
                    ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3725972e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3725972e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/gleba/ModalVisualizarGleba.vue
// module id = null
// module chunks = 